export default "__VITE_ASSET__CWunYZuB__"